import React, { useState, useCallback, useEffect, useRef } from "react";
import { Colors, Routes } from "../../../configs";
import { useHistory } from "react-router-dom";
import useModalWithKeyboard from "../../../hooks/useModalWithKeyboard";
import {
  deleteLogoImage,
  deleteSignatureImage,
  uploadLogoImage,
  uploadMyProfileImage,
} from "../../../modules/ApiHelpers";
import { Image } from "react-native";

import APIService from "../../../modules/apiService";
import AuthService from "../../../modules/authService";
import Helpers from "../../../modules/helpers";
import {
  EVENT_LOAD_SIGNATURE,
  EVENT_RELOAD_PRESCRIPTION_PROFILES,
  EVENT_SHOW_MODAL_INFO,
} from "../../../constants/Events";
import locales_es from "../../../locales/es";
import { validateEmptyFields } from "../../../utils/validation/forms";
import { EventRegister } from "../../../modules/EventRegister";
import { showModalInfo } from "../../../modules/ViewHelpers";
import AddSignature from "../../AddSignature";
import { useTheme } from "../../../configs/Theme";
import TranslationService from "../../../locales";
import { userTemporalDataPostRegister } from "../../../models/constants";
import Text from "../../../components/Text";
import PrescriptionService from "../../../modules/PrescriptionService";
import { SOURCE_ICON } from "../../../images";

const CUSTOM_STAMP_MAX_WORD_LENGTH = 40;
const CUSTOM_STAMP_MAX_WORD_LENGTH_3 = 25;

const useOtherInformationPage = () => {
  const history = useHistory();
  const params: any = history.location.state;
  let { stepTitle, firstProfile, updateStamp }: any = params && params ? params : null;
  const auth = new AuthService();

  let medicalLicenseId =
    params && params.medicalLicenseId ? params.medicalLicenseId : null;

  const prescriptionService = new PrescriptionService();
  const prescriptionIdFromStorage = prescriptionService.get();

  let prescriptionProfileId =
    params && params.prescriptionProfileId
      ? params.prescriptionProfileId
      : prescriptionIdFromStorage;
  const api = new APIService();
  const helpers = new Helpers();
  const translationService = new TranslationService();
  const [errors, setErrors] = useState<any>([]);
  const [currentPrescriptionProfile, setCurrentPrescriptionProfile] =
    useState<any>({});
  const [load, setLoad] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [loadingText, setLoadingText] = useState<string>("");
  const [name, setName] = useState<string>("");
  const [nameStep, setNameStep] = useState<boolean>(false);
  const imgLoadAndCrop: any = useRef();
  const [cropping, setCropping] = useState<boolean>(false);
  const [logoImage, setLogoImage] = useState<any>(null);
  const [clinicId, setClinicId] = useState<any>(null);
  const [signatureImage, setSignatureImage] = useState<any>(null);
  const [address, setAddress] = useState<string>("");
  const [stamp, setStamp] = useState<any>();
  const [stampErrorFlag, setStampErrorFlag] = useState<boolean>(false);
  const [stampRequiredError, setStampRequiredError] = useState<boolean>(false);
  const [stampEditorEnabled, setStampEditorEnabled] = useState<boolean>(false);
  const [defaultStampPreview, setDefaultStampPreview] = useState<any>(null);
  const [translations, setTranslations] = useState<any>(null);
  const [showStep, setShowStep] = useState<boolean>(false);
  const [clinicData, setClinicData] = useState<any>({});
  const [medicalLicense, setMedicalLicense] = useState<any>(null);
  const [idPrescriptionProfile, setIdPrescriptionProfile] = useState<any>(null);
  const [overlay, setOverlay] = useState<any>(false);
  const [userData, setUserData] = useState<any>({});
  const [stampLimitMessage, setStampLimitMessage] = useState<any>(null);

  const { theme }: any = useTheme();
  const stampRef = React.createRef();

  const validateCustomStamp = ({ stamp }: any) => {
    let wordLengthErrors: any = [];
    let lineLengthError = false;
    let errorMessagesIn: string[] = [];

    if (stamp) {
      const divStamp = stamp?.split(/\n/);
      for (let index = 0; index < divStamp.length; index++) {
        const line = divStamp[index];
        const limit = (index === 0 || index === 1) ? CUSTOM_STAMP_MAX_WORD_LENGTH : CUSTOM_STAMP_MAX_WORD_LENGTH_3;
        if (line.length > limit) {
          wordLengthErrors.push(index + 1);
          errorMessagesIn.push(`Se permite un máximo de ${limit} caracteres para la línea ${index + 1}`);
        }
      }
      lineLengthError = stamp?.split(/\n/).length > 3;
    }
    
    setStampLimitMessage(!!errorMessagesIn.length ? errorMessagesIn.join('\n') : null);
    setStampErrorFlag(wordLengthErrors.length > 0 || lineLengthError);
    return {
      wordLengthErrors,
      lineLengthError,
    };
  };


  const onSubmit = () => {
    sessionStorage.removeItem(userTemporalDataPostRegister);
    const errors = validateEmptyFields({
      name,
    });

    if (errors.length) {
      setErrors(errors);
      showModalInfo(locales_es.infoModal.title, locales_es.infoModal.checkData);
    } else {
      setLoading(true);
      const objData: any = {
        medical_license_id: medicalLicenseId,
        name,
        address,
        stamp: stampEditorEnabled ? stamp : defaultStampPreview,
        personalized_stamp: stampEditorEnabled ? 1 : 0,
        optional_fields: [], // NO SUPPORT FOR NOW
        logo_image: logoImage,
        signature_image: signatureImage,
      };

      if (prescriptionProfileId) {
        objData.active_charger_account =
          currentPrescriptionProfile.active_charger_account;
        api
          .putPrescriptionProfile(prescriptionProfileId, objData)
          .then(() => {
            sendEvent();
            setLoading(false);
            goToNextStep();
          })
          .catch((err: any) => {
            showModalInfo(
              locales_es.errorModal.title,
              helpers.getErrorMsg(err)
            );
            setLoading(false);
          });
      } else {
        api
          .postPrescriptionProfile(objData)
          .then((res: any) => {
            setLoading(false);
            prescriptionProfileId = res.data.id;
            goToNextStep();
          })
          .catch((err: any) => {
            showModalInfo(
              locales_es.errorModal.title,
              helpers.getErrorMsg(err)
            );
            setLoading(false);
          });
      }
    }
  };

  const goToNextStep = () => {
    if (updateStamp) {
      history.replace(`/${params.from == 'addPrescription' ? Routes.AddPrescription : Routes.AddCertificate}`, {
        ...(params.from === 'addCertificate' && { certificateData: params.prevPrescriptionData }),
        ...(params.from === 'addPrescription' && { prevPrescriptionData: params.prevPrescriptionData }),
        patientId: params.patientId ?? null,
      });
      return;
    }
    if (
      ((clinicData && clinicData.paylink_enabled) || !clinicData) &&
      !firstProfile
    ) {
      history.push(`/${Routes.PaymentInformation}`, {
        hasTwoSteps: false,
        hasSignup: false,
        stepTitle: "Ultimo Paso",
        stepNumber: 3,
        prescriptionProfileId,
      });
    } else {
      const emails = [
        {
          value: userData && userData.email ? userData.email : "",
        },
      ];
      history.push(`/${Routes.CreatingYourFirstPrescription}`, {
        emails,
        prescriptionProfileId,
      });
    }
  };

  const confirmRemoveLogoImage = () => {
    setLoading(true);
    deleteLogoImage(prescriptionProfileId)
      .then(() => {
        sendEvent();
        setLoading(false);
        setLogoImage(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const onRemoveLogoImage = () => {
    EventRegister.emit(EVENT_SHOW_MODAL_INFO, {
      title: locales_es.removeImageModal.title,
      message: locales_es.removeImageModal.subtitle,
      actions: [
        {
          text: locales_es.cancel,
          onPress: () => console.log("Cancel Pressed"),
          white: true,
        },
        {
          text: locales_es.removeImageModal.primaryAction,
          onPress: () => {
            confirmRemoveLogoImage();
          },
          white: true,
          colors: [Colors.Tomato, Colors.Red],
        },
      ],
    });
  };

  const confirmRemoveSignatureImage = () => {
    if (prescriptionProfileId) {
      setLoading(true);
      deleteSignatureImage(prescriptionProfileId)
        .then(() => {
          sendEvent();
          setLoading(false);
          setSignatureImage(false);
        })
        .catch(() => {
          setLoading(false);
        });
    } else {
      setSignatureImage(false);
    }
  };

  const onRemoveSignatureImage = () => {
    EventRegister.emit(EVENT_SHOW_MODAL_INFO, {
      title: locales_es.removeSignatureModal.title,
      message: locales_es.removeSignatureModal.subtitle,
      actions: [
        {
          text: locales_es.cancel,
          onPress: () => console.log("Cancel Pressed"),
          white: true,
        },
        {
          text: locales_es.deletePrescriptionProfile.primaryAction,
          onPress: () => {
            confirmRemoveSignatureImage();
          },
          white: true,
          colors: [Colors.Tomato, Colors.Red],
        },
      ],
    });
  };

  const sendEvent = () => {
    EventRegister.emit(EVENT_RELOAD_PRESCRIPTION_PROFILES);
  };

  useEffect(() => {
    translationService.translate().then((translation) => {
      setTranslations(translation);
    });
    if (prescriptionProfileId) {
      api
        .getPrescriptionProfile(prescriptionProfileId)
        .then((res: any) => {
          // setPrescriptionProfileId(res.data[0].id);
          setClinicId(res.data.clinic_id ? res.data.clinic_id : null);
          setClinicData(res.data.clinic ? res.data.clinic_id : null);
          setShowStep(true);
          setName(res.data.name);
          setAddress(res.data.address);
          setCurrentPrescriptionProfile(res.data);
          setStamp(res.data.stamp);
          validateCustomStamp({ stamp: res.data.stamp });

          setLogoImage(
            res.data.full_logo_image ? { uri: res.data.full_logo_image } : false
          );
          setSignatureImage(
            res.data.full_signature_image
              ? { uri: res.data.full_signature_image }
              : false
          );
          setDefaultStampPreview(res.data.defaultStamp.text);
          setStampEditorEnabled(res.data.personalized_stamp || updateStamp);
          /* setStamp(res.data.stamp.split(/\r?\n/)); */

          if (updateStamp) {
            setStampErrorFlag(true);
          }
          
        })
        .catch((err: any) => {
          console.log("err", err);
          helpers.getErrorMsg(err);
        });
    } else {
      api
        .getMedicalLicense(medicalLicenseId)
        .then((res: any) => {
          setMedicalLicense(res.data);
          setName("Principal");
          setShowStep(true);
          setLogoImage(false);
          setSignatureImage(false);
          setShowStep(true);
          setClinicData({ paylink_enabled: true });
          setDefaultStampPreview(res.data.defaultStamp);
        })
        .catch((err: any) => {
          console.log("err", err);
          showModalInfo(locales_es.errorModal.title, helpers.getErrorMsg(err));
        });
    }
  }, [load, userData]);

  useEffect(() => {
    const listener = EventRegister.addEventListener(
      EVENT_LOAD_SIGNATURE,
      (base64: any) => {
        if (prescriptionProfileId) {
          setLoad(!load);
        } else {
          setSignatureImage(base64);
        }
      }
    );

    return function cleanup() {
      EventRegister.removeEventListener(listener);
    };
  });

  useEffect(() => {
    auth.getRemoteUserData().then((res: any) => {
      setUserData(res.data.user);
    });
  }, []);

  const openCrop = () => {
    imgLoadAndCrop.current.selectImageFile();
  };

  const uploadImage = (image: any) => {
    if (prescriptionProfileId) {
      setLoading(true);
      setLoadingText(locales_es.uploadingImage);
      uploadLogoImage(prescriptionProfileId, image)
        .then(() => {
          setLoading(false);
          setLoadingText("");
          setLogoImage(image);
          setCropping(false);
        })
        .catch(() => {
          setLoading(false);
          setLoadingText("");
          setCropping(false);
        });
    } else {
      setLogoImage(image);
      setCropping(false);
    }
  };

  const {
    visible: visibleMenuOption,
    open: openMenuOption,
    close: closeMenuOption,
  } = useModalWithKeyboard(false);

  const onBlur = (inputStr: string) => {
    setErrors(errors.filter((item: any) => item !== inputStr));
  };

  const goToAddSignature = () => {
    // history.push(`/${Routes.AddSignature}`, {prescriptionProfileId});
    setOverlay(
      <AddSignature
        showMainModal={(
          title,
          content,
          actions,
          customStyles,
          contentCustomClassName
        ) =>
          props.showModal(
            title,
            content,
            actions,
            customStyles,
            contentCustomClassName
          )
        }
        hideMainLoading={props.hideMainLoading}
        onFinish={() => {
          setOverlay(null);
        }}
        prescriptionProfileId={prescriptionProfileId}
      />
    );
  };

  const onSend = useCallback(() => {
    const dataRequired: any = {
      address,
    };
    if (stampEditorEnabled) {
      dataRequired.stamp = stamp;
    }
    const errors = validateEmptyFields(dataRequired);
    if (errors.includes("stamp")) {
      setStampRequiredError(true);
    }
    let stampErrors: any = {};

    stampErrors = validateCustomStamp({
      stamp: stampEditorEnabled ? stamp : defaultStampPreview,
    });

    if (
      errors.length ||
      stampErrors.wordLengthErrors.length ||
      stampErrors.lineLengthError
    ) {
      setErrors(
        stampErrors.wordLengthErrors?.length ? [...errors, "stamp"] : errors
      );
      showModalInfo(
        locales_es.infoModal.title,
        [
          locales_es.infoModal.checkData,
          stampErrors.wordLengthErrors
            ? stampErrors.wordLengthErrors.map((w: any) =>
                locales_es.customStampWordLength({
                  w,
                  CUSTOM_STAMP_MAX_WORD_LENGTH: w > 2 ? CUSTOM_STAMP_MAX_WORD_LENGTH_3 : CUSTOM_STAMP_MAX_WORD_LENGTH,
                })
              )
            : undefined,
          stampErrors.lineLengthError
            ? locales_es.stampMaxLineLength
            : undefined,
        ]
          .filter((w) => !!w)
          .join(". ")
      );
    } else {
      console.log("no errors", { clinicData });
      if (clinicData && !clinicData.paylink_enabled) {
        setNameStep(true);
      } else if (firstProfile) {
        setNameStep(true);
      } else {
        onSubmit();
      }
    }
  }, [address, stamp, stampEditorEnabled, clinicData]);

  const renderWarningSign = () => {
    return (
      <Text size={13} lineHeight={20} marginTop={10} marginLeft={5}>
        <Image
          source={SOURCE_ICON.warning}
          style={{ height: 14, width: 14 }}
          resizeMode="contain"
        />{" "}
        {locales_es.nonEditableProfileField}.
      </Text>
    );
  };

  const showWarningInfo = () => {
    showModalInfo(
      locales_es.infoModal.title,
      locales_es.nonEditableProfileFieldInfo
    );
  };

  return {
    showWarningInfo,
    onSend,
    onBlur,
    openMenuOption,
    uploadImage,
    openCrop,
    onRemoveSignatureImage,
    confirmRemoveSignatureImage,
    onRemoveLogoImage,
    confirmRemoveLogoImage,
    goToNextStep,
    onSubmit,
    stampRef,
    theme,
    translations,
    loading,
    loadingText,
    nameStep,
    cropping,
    setCropping,
    logoImage,
    clinicId,
    signatureImage,
    imgLoadAndCrop,
    address,
    setAddress,
    setNameStep,
    setName,
    setStamp,
    stamp,
    errors,
    name,
    prescriptionProfileId,
    setStampEditorEnabled,
    stampErrorFlag,
    stampRequiredError,
    stampEditorEnabled,
    defaultStampPreview,
    goToAddSignature,
    renderWarningSign,
    overlay,
    setStampRequiredError,
    validateCustomStamp,
    showStep,
    clinicData,
    stepTitle,
    firstProfile,
    updateStamp,
    stampLimitMessage
  };
};

export default useOtherInformationPage;
